import React from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import Select from "../../components/Select";
import Search from "../../components/Search";
import Button from "../../components/Button";
import MailBox from "../../components/MailBox";
import { useSelector, useDispatch } from "react-redux";
import PropertyItem from "../../components/PropertyItem";
import PropertyGrid from "../../components/PropertyGrid";
import Sidebar from "../../components/Sidebar";
const Index = () => {
  const dispatch = useDispatch();
  const properties = useSelector((state) => state.properties.data);

  const data = {
    categories: {
      buy: {
        subcategories: {
          residential: {
            subsubcategories: {
              houses: {
                details: {
                  society_name: {},
                  bedrooms: {},
                  bathrooms: {},
                  keywords: [],
                  sub_features: {
                    main: [],
                    other: [],
                  },
                },
              },
              plots: {
                details: {
                  society_name: {},
                  size: {},
                  keywords: [],
                  sub_features: {
                    main: [],
                    other: [],
                  },
                },
              },
            },
          },
        },
      },
      society: {
        subcategories: {
          residential: {
            subsubcategories: {
              houses: {
                details: {
                  bedrooms: {},
                  bathrooms: {},
                  keywords: [],
                  sub_features: {
                    main: [],
                    other: [],
                  },
                },
              },
              commercial: {
                details: {},
              },
            },
          },
        },
      },
    },
  };

  return (
    <Pageslayout>
      <div className="">
        <div className="">
          {/* <div className="flex w-full justify-between items-center  border-b"> */}
          {/* <h1 className="text-[24px] text-[#030303] text-center p-2">
              Properties for Rent in Pakistan
            </h1>{" "} */}
          <div className="flex gap-2 py-2 flex-wrap md:flex-nowrap">
            <ul className="flex justify-center items-center w-full gap-4 ">
              {Object.keys(data.categories).map((category, index) => {
                <li className="font-semibold text-[18px] px-[2px] hover:underline cursor-pointer">
                  {category[index]}
                </li>;
              })}
            </ul>
            {/* <Button
              buttonText="ALL"
              isbg="true"
              bgcolor={"bgwhite"}
              textcolor="text-white"
            />
            <Button
              buttonText="Frunished"
              isbg="true"
              bgcolor={"bgwhite"}
              textcolor="text-white"
            />
            <Button
              buttonText="Unfurnished"
              isbg="true"
              bgcolor={"bgwhite"}
              textcolor="text-white"
            /> */}
          </div>
          {/* </div> */}
        </div>
        <div className="flex gap-4  flex-wrap lg:flex-nowrap">
          <div className="w-full lg:w-1/5 p-4">
            <Sidebar data={data} />
          </div>
          <div className="lg:w-4/5">
            <PropertyGrid properties={properties} />
          </div>
        </div>
      </div>
    </Pageslayout>
  );
};

export default Index;
